export default __webpack_public_path__ + "static/media/new_dashboard_careplan_headingicon.2f6f682d.svg";